import { dataSaveSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSaveSolid = /*#__PURE__*/createIcon(dataSaveSolid)
export default IconSaveSolid
